import '@bootstrap-css';
import '@/bundles/jquery';
import '@/bundles/font-awesome';
import '~/fonts/nunito_sans/font.css';
import '~/css/shared/common-deprecated.css';
import '~/css/shared/social-icons.css';
import '~/css/shared/buttons-deprecated.css';
import '~/css/shared/forms-deprecated.css';
//import '~/css/shared/select2.css';
//import '~/css/shared/modal-ab.css';
//import '~/css/shared/modal-new.css';
//import '~/css/shared/popover.css';
//import '~/css/shared/alerts.css';
//import '~/css/shared/sections.css';
//import '~/css/shared/pagination.css';
//import '~/css/shared/panel.css';
//import '~/css/shared/tooltips.css';
//import '~/css/shared/md-checkbox.css';
//import '~/css/shared/custom-checkbox.css';
//import '~/css/shared/new-radio.css';
//import '~/css/shared/new-switch.css';
//import '~/css/shared/carousel-indicators.css';
//import '~/css/shared/media-object.css';
//import '~/css/shared/labels.css';
//import '~/css/shared/tinymce.css';
//import '~/css/shared/progress-bar.css';
//import '~/css/shared/tabs-menu.css';
import '@/shared/navbar-v1/navbar-legacy';
import '@/shared/lazy-images';
import '@/shared/save-referrer-utm';
import '@/bundles/footer';

if (global.isLoggedIn) {
    import('@/shared/modal-profile-complete');
    import('@/shared/push-notifications/loader');
    import('@/shared/online-users');
    // import('@/shared/unread-messages-counter'); // it loads the whole chat component which is 0.5Mb - need to rewrite this functionality
    import('@/shared/log-user-visit');
} else {
    import('@/shared/auth-popup-loader');
    import('@/shared/cookies-consent-dialog');
}

if (global.isAdmin) {
    import('~/css/shared/admin-edit-purge.css');
}
